import { render, staticRenderFns } from "./designPage.vue?vue&type=template&id=369f0ecc&scoped=true"
import script from "./designPage.vue?vue&type=script&lang=js"
export * from "./designPage.vue?vue&type=script&lang=js"
import style0 from "./designPage.vue?vue&type=style&index=0&id=369f0ecc&prod&scoped=true&lang=css"
import style1 from "./designPage.vue?vue&type=style&index=1&id=369f0ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f0ecc",
  null
  
)

export default component.exports